import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaReact, FaJs, FaHtml5, FaCss3Alt, FaGitAlt, 
  FaFigma, FaSass, FaBootstrap 
} from 'react-icons/fa';
import { SiAngular, SiTailwindcss, SiRedux, SiNextdotjs, SiVuedotjs, SiTypescript } from 'react-icons/si';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Frontend Development',
      skills: [
        { name: 'React.js', icon: FaReact, level: 95, color: '#61DAFB' },
        { name: 'JavaScript', icon: FaJs, level: 90, color: '#F7DF1E' },
        { name: 'Angular', icon: SiAngular, level: 80, color: '#3178C6' },
        { name: 'HTML5', icon: FaHtml5, level: 95, color: '#E34F26' },
        { name: 'CSS3', icon: FaCss3Alt, level: 90, color: '#1572B6' },
        { name: 'TypeScript', icon: SiTypescript, level: 70, color: '#E34F26' }
      ]
    },
    {
      title: 'CSS Frameworks & Styling',
      skills: [
        { name: 'Tailwind CSS', icon: SiTailwindcss, level: 80, color: '#06B6D4' },
        { name: 'Sass/SCSS', icon: FaSass, level: 85, color: '#CC6699' },
        { name: 'Bootstrap', icon: FaBootstrap, level: 95, color: '#7952B3' },
        { name: 'Styled Components', icon: FaCss3Alt, level: 75, color: '#DB7093' }
      ]
    },
    {
      title: 'Tools & Technologies',
      skills: [
        { name: 'Redux', icon: SiRedux, level: 80, color: '#764ABC' },
        { name: 'Next.js', icon: SiNextdotjs, level: 50, color: '#000000' },
       
        { name: 'Git', icon: FaGitAlt, level: 85, color: '#F05032' },
        { name: 'Figma', icon: FaFigma, level: 85, color: '#F24E1E' }
      ]
    }
  ];

  return (
    <section id="skills" className="skills section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Skills & Expertise
        </motion.h2>
        
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          My technical skills and proficiency levels in frontend technologies
        </motion.p>

        <div className="skills-content">
          {skillCategories.map((category, categoryIndex) => (
            <motion.div
              key={category.title}
              className="skill-category"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 + categoryIndex * 0.2 }}
              viewport={{ once: true }}
            >
              <h3 className="category-title">{category.title}</h3>
              <div className="skills-grid">
                {category.skills.map((skill, skillIndex) => (
                  <motion.div
                    key={skill.name}
                    className="skill-card"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.4 + skillIndex * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ scale: 1.05 }}
                  >
                    <div className="skill-header">
                      <div 
                        className="skill-icon"
                        style={{ color: skill.color }}
                      >
                        <skill.icon />
                      </div>
                      <div className="skill-info">
                        <h4 className="skill-name">{skill.name}</h4>
                        <span className="skill-level">{skill.level}%</span>
                      </div>
                    </div>
                    
                    <div className="skill-progress">
                      <motion.div
                        className="progress-bar"
                        initial={{ width: 0 }}
                        whileInView={{ width: `${skill.level}%` }}
                        transition={{ duration: 1, delay: 0.5 + skillIndex * 0.1 }}
                        viewport={{ once: true }}
                        style={{ backgroundColor: skill.color }}
                      />
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="skills-summary"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="summary-card">
            <h3>Why Choose Me?</h3>
            <ul>
              <li>✅ Frontend development expertise</li>
              <li>✅ Modern and responsive design</li>
              <li>✅ Clean and maintainable code</li>
              <li>✅ Performance optimization</li>
              <li>✅ Responsive and accessible design</li>
              <li>✅ Continuous learning and adaptation</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills; 